module.exports = __webpack_public_path__ + "static/media/measurement.00a11f4b.svg";